import { inject, Injectable } from '@angular/core';
import {
  PageTitleMap,
  PageTitleService,
} from '@rd/core/services/page-title/page-title.service';
import { BNZ_BANKWIDE_UPDATES_ENABLED } from '../tokens/features.tokens';

@Injectable()
export class BnzPageTitleService extends PageTitleService {
  isBnzBankwideUpdatesEnabled = inject(BNZ_BANKWIDE_UPDATES_ENABLED);
  updatePageTitleMap = {
    ...this.pageTitleMap,
    'offer-details': this.isBnzBankwideUpdatesEnabled
      ? 'offer.details.page_title.update'
      : 'offer.details.page_title',
    'offer-listing': this.isBnzBankwideUpdatesEnabled
      ? 'offer.listing.page_title.update'
      : 'offer.listing.page_title',
  };

  setPageTitle(
    page: keyof PageTitleMap,
    params?: { [key: string]: string },
  ): void {
    if (this.useCustomPageTitle) {
      this.pageTitleKey = page;
      const pageTitle = this.translateService.instant(
        this.updatePageTitleMap[page],
        {
          ...this.defaultTranslationParams(),
          ...params,
        },
      );

      if (!pageTitle) {
        const error = `Missing translation in page ${page} for key ${this.updatePageTitleMap[page]}`;

        this.sentryService.manualError(error);
      }

      this.titleService.setTitle(pageTitle);
    }
  }
}
